__turbopack_context__.v({
  "root": "Body-module__xPVAQa__root",
});
